export default "/imgs/logo/brand-name-500.png"